import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Image, Alert, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaShieldAlt, FaDirections, FaWhatsapp } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const mainColor = '#006186';

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    code: '',
  });

  const [verificationCode, setVerificationCode] = useState(generateVerificationCode());
  const [isCodeCorrect, setIsCodeCorrect] = useState(true);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  function generateVerificationCode() {
    return Math.floor(1000 + Math.random() * 9000);
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const refreshCaptcha = () => {
    setVerificationCode(generateVerificationCode());
    setFormData({ ...formData, code: '' });
    setIsCodeCorrect(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Проверка капчи
    if (formData.code !== String(verificationCode)) {
      setIsCodeCorrect(false);
      return;
    }
    
    setIsCodeCorrect(true);
    
    // Формируем сообщение для email
    const subject = `Сообщение от ${formData.name}`;
    const body = `Имя: ${formData.name}%0AEmail: ${formData.email}%0A%0AСообщение:%0A${formData.message}`;
    
    // Открываем почтовый клиент
    window.location.href = `mailto:oshtu.adyshev@mail.ru?subject=${encodeURIComponent(subject)}&body=${body}`;
    
    setIsFormSubmitted(true);
    setFormData({ name: '', email: '', message: '', code: '' });
    setVerificationCode(generateVerificationCode());
  };

  const openWhatsApp = () => {
    const phone = '996322243883'; // Номер телефона (без +)
    const message = 'Здравствуйте! У меня вопрос по ассоциации выпускников ОшТУ.';
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const mapUrl = "https://www.google.com/maps/search/?api=1&query=ОшТУ+Ош+ул+Исанова+81";

  return (
    <div className="contact-page bg-white">
      <section className="news-hero py-5">
        <Container>
          <h1 className="display-4 fw-bold mb-3" style={{ color: '#006186' }}>Контакты</h1>
          <div className="header-line mb-4" style={{ backgroundColor: mainColor, width: '80px', height: '5px' }}></div>
        </Container>
      </section>

      <Container className="py-5">
        <Row className="g-5">
          {/* ЛЕВАЯ КОЛОНКА */}
          <Col lg={5}>
            <Card className="border-0 shadow-sm rounded-4 overflow-hidden mb-4">
              <div className="p-4 bg-light d-flex align-items-center justify-content-center">
                <Image
                  src="https://cojo.ru/wp-content/uploads/2022/12/avatarka-38.webp"
                  alt="Асан Усонов"
                  roundedCircle
                  className="shadow-sm border border-4 border-white"
                  style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                />
              </div>
              <Card.Body className="p-4">
                <h3 className="fw-bold text-dark mb-1">Айдаралиев Уларбек</h3>
                <p className="fw-semibold mb-4" style={{ color: mainColor }}>Руководитель отдела по связям с выпускниками</p>

                <div className="contact-info-list">
                  <div className="d-flex mb-3">
                    <FaMapMarkerAlt className="me-3 mt-1" style={{ color: mainColor }} />
                    <p className="mb-0 text-muted">ул. Исанова 81<br />Ош, Кыргызстан 723503</p>
                  </div>
                  <div className="d-flex mb-3">
                    <FaPhone className="me-3 mt-1" style={{ color: mainColor }} />
                    <p className="mb-0 text-muted">(+996 3222) 4 3883</p>
                  </div>
                  <div className="d-flex mb-3">
                    <FaEnvelope className="me-3 mt-1" style={{ color: mainColor }} />
                    <a href="mailto:oshtu.adyshev@mail.ru" className="text-decoration-none" style={{ color: mainColor }}>oshtu.adyshev@mail.ru</a>
                  </div>
                </div>
              </Card.Body>
            </Card>

            {/* КАРТА ОшТУ */}
            <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
              <div style={{ height: '300px', width: '100%' }}>
                <iframe
                  title="OshTU Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3034.425987977457!2d72.83000871221714!3d40.48751555184857!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38bdbe4097a292ad%3A0x8567fbda260a879f!2z0J7RiNCi0KM!5e0!3m2!1sru!2skg!4v1715600000000!5m2!1sru!2skg"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
              <Button
                variant="light"
                href={mapUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-0 border-top d-flex align-items-center justify-content-center gap-2 py-3 fw-bold"
                style={{ color: mainColor }}
              >
                <FaDirections /> Открыть в навигаторе
              </Button>
            </Card>
          </Col>

          {/* ПРАВАЯ КОЛОНКА */}
          <Col lg={7}>
            <div className="form-container p-4 p-md-5 rounded-4 bg-light-subtle shadow-sm border">
              <h4 className="fw-bold mb-4 text-dark text-uppercase">Напишите нам</h4>
              
              {isFormSubmitted ? (
                <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
                  <Alert variant="success" className="border-0 shadow-sm text-center">
                    <h5 className="fw-bold mb-2">Откройте почту!</h5>
                    <p>Ваш почтовый клиент был открыт для отправки сообщения.</p>
                    <Button 
                      variant="outline-success" 
                      onClick={() => setIsFormSubmitted(false)}
                      className="mt-2"
                    >
                      Отправить еще сообщение
                    </Button>
                  </Alert>
                </motion.div>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Label className="small fw-bold">Ваше имя *</Form.Label>
                      <Form.Control
                        type="text" 
                        name="name" 
                        value={formData.name}
                        onChange={handleChange} 
                        required 
                        className="border-0 shadow-sm py-2"
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Label className="small fw-bold">Ваш Email *</Form.Label>
                      <Form.Control
                        type="email" 
                        name="email" 
                        value={formData.email}
                        onChange={handleChange} 
                        required 
                        className="border-0 shadow-sm py-2"
                      />
                    </Col>
                  </Row>

                  <Form.Group className="mb-4">
                    <Form.Label className="small fw-bold">Сообщение *</Form.Label>
                    <Form.Control
                      as="textarea" 
                      rows={4} 
                      name="message" 
                      value={formData.message}
                      onChange={handleChange} 
                      required 
                      className="border-0 shadow-sm py-2"
                    />
                  </Form.Group>

                  <Form.Group className="mb-4 p-3 rounded-3 bg-white shadow-sm border">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <Form.Label className="d-flex align-items-center mb-0">
                        <FaShieldAlt className="me-2" style={{ color: mainColor }} />
                        <span>Введите проверочный код:</span>
                      </Form.Label>
                      <Button 
                        variant="link" 
                        onClick={refreshCaptcha}
                        className="p-0 text-decoration-none"
                        style={{ color: mainColor }}
                      >
                        Обновить код
                      </Button>
                    </div>
                    <div className="text-center mb-3">
                      <span className="fw-bold fs-2" style={{ letterSpacing: '8px', color: mainColor }}>
                        {verificationCode}
                      </span>
                    </div>
                    <Form.Control
                      type="text" 
                      name="code" 
                      value={formData.code}
                      onChange={handleChange} 
                      required 
                      placeholder="Введите 4-значный код"
                      className="text-center fw-bold fs-4 border-0 bg-light py-2"
                      maxLength="4"
                    />
                    {!isCodeCorrect && (
                      <Alert variant="danger" className="mt-2 py-2 border-0 small">
                        Неверный код. Попробуйте снова.
                      </Alert>
                    )}
                  </Form.Group>

                  <Button
                    type="submit"
                    className="w-100 py-3 fw-bold border-0 text-uppercase d-flex align-items-center justify-content-center gap-2"
                    style={{ backgroundColor: mainColor, letterSpacing: '1px' }}
                  >
                    <FaEnvelope /> Отправить сообщение
                  </Button>
                </Form>
              )}

              <div className="text-center mt-4">
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;